import React from 'react'
import PropTypes from 'prop-types'
import { getIn } from 'formik'
import TimeSelectRaw from '~/components/common/TimeSelect'

const TimeSelect = ({ field, form, disabled, ...props }) => (
  <TimeSelectRaw
    {...field}
    error={
      !!getIn(form.touched, field.name) && !!getIn(form.errors, field.name)
    }
    helperText={
      getIn(form.touched, field.name) && getIn(form.errors, field.name)
    }
    disabled={disabled || !!form.values.__readOnly}
    form={form}
    {...props}
  />
)

TimeSelect.defaultProps = {
  disabled: false,
}

TimeSelect.propTypes = {
  form: PropTypes.shape().isRequired,
  field: PropTypes.shape().isRequired,
  disabled: PropTypes.bool,
}

export default TimeSelect
